// eslint-disable-next-line unused-imports/no-unused-imports
import { GenericLink, useFeatureVisibility, GenericLinkProps } from '@nextgen-web-framework/all';
import { FC } from 'react';
import { createPDPRedirectionUrl } from '@commerce-product-webcomponents/sdk';
import { FeatureFlags } from '../../../common/types';
import styles from './ProductLink.module.scss';
import type { ProductLinkPropsTypes, ProductLinkPropsWithLink } from './types/propsTypes';

const ProductLink = (Component: FC<GenericLinkProps>) => {
  const ProductLinkComponent = (props: ProductLinkPropsTypes): JSX.Element => {
    const config = ConfigService.getConfigs();
    const isPDPRouteSEOSupportAvailable = config.NEXT_PDP_ROUTE_SEO_FEATURE as boolean;
    const isPDPRouteSEOSupportAvailableFF = useFeatureVisibility(FeatureFlags.pdpSeoRoute);

    const { children, className, isSop = false, showLink = true, onClick } = props;
    if (showLink) {
      let url = '';
      const { productId, productName = '' } = props as ProductLinkPropsWithLink;
      url =
        isPDPRouteSEOSupportAvailable || isPDPRouteSEOSupportAvailableFF
          ? createPDPRedirectionUrl(productId, productName)
          : `/product/${productId}`;
      if (isSop) {
        url += `?sop=true`;
      }
      return (
        <Component
          href={url}
          legacyBehavior={false}
          forceNative={false}
          key={productId}
          data-testid={'href-test-id'}
          className={`${className} ${styles['cpw-no-decoration']}`}
          onClick={onClick}
        >
          {children}
        </Component>
      );
    }
    return <div className={`${className} ${styles['cpw-no-link']}`}>{children}</div>;
  };
  return ProductLinkComponent;
};

export default ProductLink(GenericLink);
export type { ProductLinkPropsTypes };
